import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';

@Component({
  selector: 'app-grid-controls',
  imports: [CommonModule],
  templateUrl: './grid-controls.component.html',
  styleUrls: ['./grid-controls.component.scss'],
})
export class GridControlsComponent {
  key = input.required<string>();
  row = input.required<any>();
  hasPermissionEdit = input.required<boolean>();
  hasPermissionDelete = input.required<boolean>();
  showInfoButton = input<boolean>(false);

  edit = output<{ row: any; key: string }>();
  confirmDelete = output<{ event: any; row: any; key: string }>();

  onEditClick(event: MouseEvent): void {
    event.stopPropagation();
    this.edit.emit({ row: this.row(), key: this.key() });
  }

  onDeleteClick(event: MouseEvent): void {
    event.stopPropagation();
    this.confirmDelete.emit({
      event,
      row: this.row(),
      key: this.key(),
    });
  }
}
